export default __webpack_public_path__ + "static/media/overlay.e035cf7d.webp";